export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="/">
            <span>
              <img
                src="img/ootd-logo.png"
                alt="OOTD"
                width={33}
                style={{
                  margin: "0 5 5 0",
                  verticalAlign: "middle",
                  border: "2px solid #ccc",
                  borderRadius: "5px",
                  boxShadow:
                    "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
                }}
              />
              OOTD
            </span>
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {/* <li>
              <a href="/#features" className="page-scroll">
                Features
              </a>
            </li> */}
            {/* <li>
              <a href='#about' className='page-scroll'>
                About
              </a>
            </li> */}
            {/* <li>
              <a href='#services' className='page-scroll'>
                Services
              </a>
            </li> */}
            {/* <li>
              <a href='#portfolio' className='page-scroll'>
                Gallery
              </a>
            </li> */}
            <li>
              <a href="/#/signup">Get Early Access</a>
            </li>
            <li>
              <a href="/#/privacy-policy">Privacy Policy</a>
            </li>
            <li>
              <a href="/#/terms-of-service">Terms of Service</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
